import { Box } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { formatCasePack, formatUnitNetWeight } from "components/Products/utils";

const fragment = gql(/* GraphQL */ `
  fragment SkuPackSize on Sku {
    id
    unitNetWeight
    unitNetWeightUnit
    productLine {
      id
      wholesaleCaseQuantity
      innerCaseQuantity
    }
  }
`);

type Props = {
  sku: FragmentType<typeof fragment>;
};

export default function SkuPackSize({ sku: skuFragment }: Props) {
  const sku = getFragmentData(fragment, skuFragment);

  const casePack =
    formatCasePack(
      sku.productLine?.wholesaleCaseQuantity,
      sku.productLine?.innerCaseQuantity,
    ) || "";

  const unitNetWeight = formatUnitNetWeight(
    sku.unitNetWeight,
    sku.unitNetWeightUnit,
  );

  if (!casePack && !unitNetWeight) return null;

  return (
    <Box fontSize=".75em" color="gray.500" mt=".25em">
      {casePack}
      {casePack && !unitNetWeight && " pack"}
      {casePack && unitNetWeight ? `/` : ""}
      {unitNetWeight}
    </Box>
  );
}
